import { useState, useEffect, useRef } from 'react';
import { Button, Space, Spin, notification, Modal } from 'antd';
import RichText from 'components/RichText';
import XTable from 'components/XTable';
import { contentType } from 'enumeration/contentType';
import { getFilterText } from 'utils';
import { getUserNoticeByIdApi, postUserNoticeByIdApi, getContentListApi } from 'api/userNotice';
import { LoadingOutlined } from '@ant-design/icons';
const NoticeEdit = () => {
    const [disabled, setDisabled] = useState(true);
    const [loading, setLoading] = useState(true);
    const [currentVal, setCurrentVal] = useState('');
    const [oldVal, setOldVal] = useState('');
    const [richTextKey, setRichTextKey] = useState('');
    const [okBtnLoading, setokBtnLoading] = useState(false);
    const [modalVisible, setmodalVisible] = useState(false);
    const [id, setid] = useState('');
    const [type, setType] = useState('');

    const showModal = data => {
        const { id, type } = data;
        const key = new Date().getTime() + '';
        setRichTextKey(key);

        setType(type);
        setid(id);
        setmodalVisible(true);
        setokBtnLoading(false);
        setDisabled(true);
        getUserNoticeByIdApi({ id: id }).then(res => {
            if (res.success) {
                console.log(res.content);
                setOldVal(res.content || '');
            }
            setLoading(false);
        });
    };

    useEffect(() => {
        const key = new Date().getTime() + '';
        setRichTextKey(key);
    }, [loading, disabled]);

    const xTableRef = useRef();

    // 富文本修改
    const onRichTextChange = code => {
        setCurrentVal(code);
    };

    // 保存
    const saveNotice = () => {
        const InfoKey = `notice_` + id;
        notification.info({
            duration: null,
            description: '提交申请中...',
            icon: <LoadingOutlined />,
            key: InfoKey,
        });
        postUserNoticeByIdApi({ content: currentVal, id: id, type: type }).then(res => {
            if (res.success) {
                setOldVal(currentVal);
                setDisabled(true);
                notification.success({
                    description: '保存成功',
                    key: InfoKey,
                });
            } else {
                notification.close(InfoKey);
            }
        });
    };

    const columns = [
        {
            title: 'id',
            dataIndex: 'id',
        },
        {
            title: '文本类型',
            dataIndex: 'type',
            render: val => getFilterText(contentType, val),
        },
        {
            title: '操作',
            dataIndex: '',
            render: (val, data) => {
                return (
                    <Space size="middle">
                        <span className="actionText" onClick={() => showModal(data)}>
                            修改
                        </span>
                    </Space>
                );
            },
        },
    ];

    const actionBtns = [];
    // 弹窗取消
    const handelCancel = () => {
        setmodalVisible(false);
        setid('');
        setType('');
    };

    return (
        <div>
            <XTable
                columns={columns}
                api={getContentListApi}
                rowKey="id"
                actionBtns={actionBtns}
                ref={xTableRef}
            />
            <Modal
                title={`编辑内容文本`}
                centered
                visible={modalVisible}
                onOk={handelCancel}
                okButtonProps={{ loading: okBtnLoading }}
                width="800"
                onCancel={handelCancel}>
                <Spin spinning={loading}>
                    <div key={richTextKey} style={{ height: 'calc(100vh - 250px)', width: 800 }}>
                        <RichText
                            defaultValue={disabled ? oldVal : currentVal} // 初始值
                            onChange={onRichTextChange} // 文本改变回调，获取文本值
                            disabled={disabled}
                        />
                    </div>
                    <div style={{ textAlign: 'center', marginTop: 10 }}>
                        {disabled ? (
                            <Button onClick={() => setDisabled(false)} type="primary">
                                编辑
                            </Button>
                        ) : (
                            <Space>
                                <Button onClick={saveNotice} type="primary">
                                    保存
                                </Button>
                                <Button onClick={() => setDisabled(true)}>取消</Button>
                            </Space>
                        )}
                    </div>
                </Spin>
            </Modal>
        </div>
    );
};
export default NoticeEdit;
